import React, { useContext } from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import ColorModeContext from "../../layout/themeContext";

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "center",
    padding: theme.spacing(1, 2),
    marginTop: theme.spacing(2),
    fontSize: 12,
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
    opacity: 0.9,
    borderTop: `1px solid ${theme.palette.divider}`,
    flexShrink: 0,
  },
  inline: {
    marginTop: theme.spacing(2),
    borderTop: "none",
    padding: theme.spacing(1, 0, 0),
  },
}));

export default function WhitelabelPoweredBy({ inline = false, className = "" }) {
  const classes = useStyles();
  const { colorMode } = useContext(ColorModeContext);
  const text = colorMode?.poweredByText;

  if (!text || !String(text).trim()) {
    return null;
  }

  return (
    <Typography
      component="footer"
      variant="caption"
      className={`${classes.root} ${inline ? classes.inline : ""} ${className}`.trim()}
    >
      {String(text).trim()}
    </Typography>
  );
}
